<template>
	<div>
		<div class="map_wrapper">
			<div class="map_on_search" @click="boundsSearch()" v-show="map_on_search_show">この表示範囲で検索</div>
			<div class="map" ref="googleMap"/>
			<div class="error_dialog" v-show="errorState">
				<p>5km以下に範囲を絞ってください。</p>
				<div class="buttons" @click="errorState = false">OK</div>
			</div>
			<div class="map_on_app" @click="linkApp()">地図アプリで見る</div>
		</div>
	</div>
</template>

<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

export default {
	name: 'Map',
	props: {
		initLat: Number,
		initLng: Number
	},
	data() {
		return {
			map: null,
			google: null,
			mapConfig: {
				center: {
					//デフォ東京
					lat: 35.6812362,
					lng: 139.7649361
				},
				zoom: 14,
				mapTypeControl: false,
				streetViewControl: false,
				scaleControl: true
			},
			errorState: false,
			firstLat: this.initLat,
			firstLng: this.initLng,
			saveMarkers_array: [],
			markerIcon: 'data:image/png;base64,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'
		}
	},
	computed: {
		//緯度経度が初回に渡されていたら、「このエリアから探す」ボタンを隠すfasle
		map_on_search_show() {
			if(this.firstLng !== undefined && this.firstLat !== undefined) {
				return false;
			} else {
				return true;
			}
		}
	},
	created() {
	},
	async mounted() {

		this.google = await GoogleMapsApiLoader({
			apiKey: 'AIzaSyBYaHjAd8eE6E-rtjV3ZXRkOsfGYePDYu8',
			libraries: ['places']
		});

		await this.getGeoPosition().then((value) => {
			this.mapConfig.center.lat = value.coords.latitude;
			this.mapConfig.center.lng = value.coords.longitude;
		}, () => {
			//error なにもせずデフォ
		});


		//マップを生成
		this.map = new this.google.maps.Map(this.$refs.googleMap, this.mapConfig);


		//マップ内にボタン「アプリで開くボタン」を置く
		let map_on_app_btn = document.querySelector(".map_on_app");
		this.map.controls[this.google.maps.ControlPosition.LEFT_BOTTOM].push(map_on_app_btn);

		//マップ内にボタン「この範囲で検索ボタン」を置く
		let map_on_search_btn = document.querySelector(".map_on_search");
		this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(map_on_search_btn);

		//コンポーネントに初期値の緯度経度が渡されていたら、マーカーを置く(shop.vue用制御)
		if(this.initLat !== undefined && this.initLng !== undefined) {
			this.mapConfig.center.lat = Number(this.firstLat);
			this.mapConfig.center.lng = Number(this.firstLng);
			this.map.setCenter(this.mapConfig.center);
			this.map.setZoom(17);
			new this.google.maps.Marker({
				position: {lat: this.firstLat, lng: this.firstLng},
				map: this.map,
				icon: {
					//url: '/shop/images/marker_pin@2x.png',
					url: this.markerIcon,
					scaledSize: new this.google.maps.Size(27, 37),
				},
				optimized: false,
			});
		}

	},
	methods: {

		//ブラウザに現在位置情報が許可されていれば読み取って反映
		getGeoPosition() {
			if(navigator.geolocation) {
				return new Promise((resolve, reject) => {
					navigator.geolocation.getCurrentPosition((position) => {
						resolve(position)
					}, () => {
						reject('error')
					},{//androidはこのおまじないつけないと動かない時がある
						enableHighAccuracy: true,
						timeout : 2000
					})
				})

			} else {
				// Browser doesn't support Geolocation
				alert('お使いのブラウザは現在位置が取得できません ');
			}
		},

		//住所から探すの検索ボタン押下で発火
		//市区町村プルダウンが選ばれていたらuni実行、無かったら都道府県のprefを実行
		//ズームイベント終わり次第、markerを立てる。何も選択無かったらスルー。
		setDisplay_premun() {
			const _this = this;
			//muni市区町村
			if(this.$store.state.selected_municipality !== '') {
				this.google.maps.event.addListenerOnce(this.map, 'zoom_changed', function () {
					_this.setDisplay_markers(true);
				});
				this.setDisplayGeoArea_muni(this.$store.state.selected_municipality);

				//pref都道府県
			} else if(this.$store.state.selected_prefectures !== '') {
				this.google.maps.event.addListenerOnce(this.map, 'zoom_changed', function () {
					_this.setDisplay_markers(true);
				});
				this.setDisplayGeoArea_pref(this.$store.state.selected_prefectures);

				//何もしない
			} else {
				return;
			}
		},

		//このふたつお金がかかりまくるようなら、座標を予め取得する事。
		//選択都道府県から緯度経度ロードして、選択都道府県を中心にマップ移動表示
		setDisplayGeoArea_pref(_value) {
			if(_value === '') return;

			const request = {
				query: _value,
				fields: ["geometry"],
			};

			let service = new this.google.maps.places.PlacesService(this.map);
			service.findPlaceFromQuery(request, (results, status) => {
				if(status === this.google.maps.places.PlacesServiceStatus.OK) {
					//this.map.setCenter(results[0].geometry.location);
					this.map.fitBounds(results[0].geometry.viewport);
				}
			});
		},

		//選択市区町村から、APIを使って緯度経度を検索して、選択市区町村を中心にマップ移動表示
		setDisplayGeoArea_muni(_value) {
			if(_value === '') return;

			const request = {
				query: _value,
				fields: ["geometry"],
			};

			let service = new this.google.maps.places.PlacesService(this.map);
			service.findPlaceFromQuery(request, (results, status) => {
				if(status === this.google.maps.places.PlacesServiceStatus.OK) {
					//this.map.setCenter(results[0].geometry.location);
					this.map.fitBounds(results[0].geometry.viewport);
				}
			});
		},


    /**
     *  境界エリア内のマーカー検索
     *      ただしズーム制限がある
     * */
		boundsSearch() {
			//5km以上（ズームレベル11以下）は検索させず注意を出す
			// if(Number(this.map.getZoom()) < 11) {
			// 	this.errorState = true;
			// 	return;
			// }

			this.setDisplay_markers();
		},

    /**
     *  【現在表示領域から、該当するショップをマーカー表示】
     *      引数が真あれば、検索ボタンからの発火として、都道府県or市区町村を絞り込む
     *      なければ一律表示領域から全部だす。
     *  @type [Boolean]
     *  */
		setDisplay_markers(_addressBool) {
			const latlngBounds = this.map.getBounds();
			const swLatlng = latlngBounds.getSouthWest();
			const swlat = swLatlng.lat();
			const swlng = swLatlng.lng();

			const neLatlng = latlngBounds.getNorthEast();
			const nelat = neLatlng.lat();
			const nelng = neLatlng.lng();

			let shop_dt = this.$store.state.excel_data;

			if(_addressBool) {
				let tmpPref_array = [];
				for (let i = 0; i < shop_dt.length; i = (i + 1) | 0) {
					if(shop_dt[i]['県名'] === this.$store.state.selected_prefectures) {
						tmpPref_array.push(shop_dt[i]);
					}
				}
				if(this.$store.state.selected_municipality !== '') {
					let tmpMuni_array = [];
					for (let i = 0; i < tmpPref_array.length; i = (i + 1) | 0) {
						if(tmpPref_array[i]['市区町村'] === this.$store.state.selected_municipality) {
							tmpMuni_array.push(tmpPref_array[i]);
						}
					}
					shop_dt = tmpMuni_array;
				} else {
					shop_dt = tmpPref_array;
				}
			}

			const return_array = []
			const infowindow = new this.google.maps.InfoWindow();
			this.removeMakers();

			for (let i = 0; i < shop_dt.length; i = (i + 1) | 0) {
				let shop_lat = shop_dt[i]['緯度'];
				let shop_lng = shop_dt[i]['経度'];
				if(swlat <= shop_lat && swlng <= shop_lng) {
					if(nelat >= shop_lat && nelng >= shop_lng) {
						return_array.push(shop_dt[i]);
						let marker_content =
							'<div style="padding: 5px 0">' +
							shop_dt[i]['販売店名'] +
							'<br>' +
							'<div><input class="buttons" onclick="app.junpShopInfo(' + shop_dt[i]['ID'] + ')" style="margin:3px auto;width: 100px;text-align: center" value="店舗情報"></div>' +
							'</div>';

						let marker = new this.google.maps.Marker({
							position: {lat: shop_dt[i]['緯度'], lng: shop_dt[i]['経度']},
							map: this.map,
							icon: {
								//url: '/shop/images/marker_pin.png',
								url: this.markerIcon,
								scaledSize: new this.google.maps.Size(27, 37),
							},
							optimized: false,
						});
						this.saveMarkers_array.push(marker);

						marker.addListener("click", function () {
							let op = {
								content: marker_content
							}
							infowindow.setOptions(op);
							infowindow.open(this.map, marker);
						});
					}
				}
			}
			this.$store.commit('SET_RESULT_SHOPLIST', return_array);
		},


		/*
		現在表示領域から、該当するショップをマーカー表示
		 */
		setDisplay_Keyword_markers(_list) {
			let shop_dt = _list;

			//左下(南西)の座標と右上(北東)の座標の2つの値を生成
			let newBoundary = new this.google.maps.LatLngBounds();

			//吹き出しの準備
			const infowindow = new this.google.maps.InfoWindow();
			this.removeMakers();

			//マーカーを生成し設置
			const return_array = [];
			for (let i = 0; i < shop_dt.length; i = (i + 1) | 0) {
				return_array.push(shop_dt[i]);
				let position = {lat: shop_dt[i]['緯度'], lng: shop_dt[i]['経度']}
				newBoundary.extend(position);
				let marker_content =
					'<div style="padding: 5px 0">' +
					shop_dt[i]['販売店名'] +
					'<br>' +
					'<div><input class="buttons" onclick="app.junpShopInfo(' + shop_dt[i]['ID'] + ')" style="margin:3px auto;width: 100px;text-align: center" value="店舗情報"></div>' +
					'</div>';

				let marker = new this.google.maps.Marker({
					position: position,
					map: this.map,
					icon: {
						//url: '/shop/images/marker_pin@2x.png',
						url: this.markerIcon,
						scaledSize: new this.google.maps.Size(27, 37),
					},
					optimized: false,
				});
				this.saveMarkers_array.push(marker);

				//マーカークリックしたら吹き出し表示
				marker.addListener("click", function () {
					let op = {
						content: marker_content
					}
					infowindow.setOptions(op);
					infowindow.open(this.map, marker);
				});
			}

			//マーカーが少なすぎで、マーカー同士が接近しすぎの場合
			//ズームが近すぎる事になるため、現時点のnewBoundaryの境界をチェックし
			//同一であればズーム過ぎると判断し一定距離はなす
			if(newBoundary.getNorthEast().equals(newBoundary.getSouthWest())) {
				var extendPoint = new this.google.maps.LatLng(newBoundary.getNorthEast().lat() + 0.01, newBoundary.getNorthEast().lng() + 0.01);
				newBoundary.extend(extendPoint);
			}

			//上記を加味した、マーカーが全て収まるズーム位置で表示
			this.map.fitBounds(newBoundary);

			//結果リストにコミット
			this.$store.commit('SET_RESULT_SHOPLIST', return_array);
		},

		removeMakers() {
			for (let i = 0; i < this.saveMarkers_array.length; i++) {
				this.saveMarkers_array[i].setMap(null);
			}
			this.saveMarkers_array = [];
		},
		/*
		app起動
		 */
		linkApp() {
			// スマホ判定
			const ua = navigator.userAgent;
			if(ua.indexOf('iPhone') >= 0 || ua.indexOf('iPad') >= 0 || ua.indexOf('iPod') >= 0) {
				location.href = 'http://maps.apple.com/?ll=' + this.mapConfig.center.lat + ',' + this.mapConfig.center.lng;
			} else if(ua.indexOf('Android') >= 0) {
				location.href = 'https://www.google.com/maps/search/?api=1&query=' + this.mapConfig.center.lat + ',' + this.mapConfig.center.lng;
			} else {
				window.open('https://www.google.com/maps/search/?api=1&query=' + this.mapConfig.center.lat + ',' + this.mapConfig.center.lng, '_blank');
			}
		}
	}
}
</script>

<style scoped>

.map_wrapper {
	position: relative;
}

.map_on_search {
	font-family: 'ヒラギノ角ゴ ProN W3', 'Noto Sans Japanese', 'Hiragino Kaku Gothic ProN', 'メイリオ', 'Meiryo', sans-serif;
	width: 225px;
	height: 34px;
	background-color: white;
	border-radius: 3px;
	border: 1px solid gray;
	margin: 5px;
	padding: 0 5px 0 62px;
	box-shadow: rgba(0, 0, 0, 0.2) 0 1px 3px;
	cursor: pointer;
	display: flex;
	justify-content: left;
	align-items: center;
	font-size: 1rem;
}

.map_on_search:before {
	content: "";
	position: absolute;
	left: 5px;
	top: 0;
	bottom: 0;
	width: 52px;
	height: 100%;
	background: url("/shop/images/icons/logo.svg") center / contain no-repeat;
}

.map_on_search:after {
	content: "";
	position: absolute;
	right: 5px;
	top: 0;
	bottom: 0;
	width: 30px;
	background: url("/shop/images/search_icon.svg") center / contain no-repeat;
}

.map_on_app {
	font-family: 'ヒラギノ角ゴ ProN W3', 'Noto Sans Japanese', 'Hiragino Kaku Gothic ProN', 'メイリオ', 'Meiryo', sans-serif;
	width: 122px;
	height: 34px;
	background-color: white;
	border-radius: 3px;
	border: 1px solid gray;
	margin: 5px;
	padding: 5px;
	box-shadow: rgba(0, 0, 0, 0.2) 0 1px 3px;
	cursor: pointer;
	display: none;
	justify-content: center;
	align-items: center;
}

.map {
	width: 100%;
	max-width: 1200px;
	height: 430px;
}

.marker {
	height: 150px;
}

.error_dialog {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	width: 300px;
	height: 100px;
	padding: 10px;
	background-color: white;
	border-radius: 10px 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-flow: column;
	box-shadow: rgba(0, 0, 0, 0.5) 0 3px 6px;
}

.buttons {
	width: 130px;
	height: 32px;
}

.buttons {
	font-weight: bold;
}

.buttons:hover {
	color: white;
}


@media (max-width: 750px) {

	.map_on_search {
		font-size: 1.2em;
	}

	.map_on_app {
		font-size: 1.2em;
		display: flex;
	}
}

</style>